import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { LoginFormStyled } from "./style";
import { yupResolver } from "@hookform/resolvers/yup";
import { loginSchema } from "./loginSchema";
import { iLoginFormValues } from "./types";
import { SubmitHandler } from "react-hook-form";
import { UserContext } from "../../../providers/UserContext";
import { ButtonStyled } from "../../../style/button";
import TextField from "@mui/material/TextField";

export const LoginForm = () => {
  const { userLogin } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<iLoginFormValues>({
    mode: "onBlur",
    resolver: yupResolver(loginSchema),
  });

  const submit: SubmitHandler<iLoginFormValues> = async (data) => {
    userLogin(data, setLoading);
  };
  return (
    <LoginFormStyled noValidate onSubmit={handleSubmit(submit)}>
      <TextField
        color="success"
        required
        id="email"
        type="email"
        label="Login"
        placeholder="Digite seu e-mail aqui"
        fullWidth
        disabled={loading}
        {...register("email")}
        error={!!errors.email}
        helperText={errors.email?.message}
      />
      <TextField
        required
        color="success"
        id="password"
        type="password"
        label="Senha"
        placeholder="Digite sua senha aqui"
        fullWidth
        disabled={loading}
        {...register("password")}
        error={!!errors.password}
        helperText={errors.password?.message}
      />
      <ButtonStyled
        type="submit"
        buttonStyle="primaryMedium"
        weigth={600}
        disabled={loading}
      >
        {loading ? "Entrando..." : "Entrar"}
      </ButtonStyled>
    </LoginFormStyled>
  );
};
